<form [formGroup]="form" class="!overflow-y-hidden">
<div >
    <h2 class="header !m-0">Approval Request Received</h2>
    <div style="position: absolute; top: 17px; right: 36px">
        <img
          src="assets/icons/cross-icon.svg"
          (click)="closeApproval()"
          alt="cross icon"
          class="cursor-pointer !fixed !w-[20px]"
        />
      </div>
    

    <div class="p-[2.5rem] !pt-0 !pb-0  flex-col justify-center items-center !mb-[30px] bg-white table-scroll">
        <div class="py-4 ">
            <table class="min-w-full bg-white border border-gray-200">
              <thead>
                <tr class="bg-[#DEE2E6]">
                  <th class="!py-4 px-4 text-[#21252A] text-[18px] font-medium  border border-gray-200 text-left w-[20%]">From</th>
                  <th class="!py-2 px-4 text-[#21252A] text-[18px] font-medium  border border-gray-200 text-left w-[15%]">Role</th>
                  <th class="!py-2 px-4 text-[#21252A] text-[18px] font-medium border border-gray-200 text-left w-[25%]">Subject</th>
                  <th class="!py-2 px-4 text-[#21252A] text-[18px] font-medium border border-gray-200 text-left ">Request Description</th>
                </tr>
              </thead>
              <tbody>
                <tr >
                  <td class="py-2 px-4 text-[1rem] text-[#000] font-medium border  border-gray-200">{{ data?.approvalSender[0].name }}</td>
                  <td class="py-2 px-4 text-[1rem] text-[#000] font-medium border border-gray-200">{{ data?.approvalSender[0].role  }}</td>
                  <td class="py-2 px-4 text-[1rem] text-[#000] font-medium border border-gray-200" >{{ data?.modalType  }}</td>
                  <td class="py-2 px-4 text-[1rem] text-[#000] font-medium border border-gray-200"
                  *ngIf="data?.note"
                  [innerHTML]="getSanitizedHtml(data?.note ||'---')"
                  ></td>
                </tr>
              </tbody>
            </table>
          </div>
        
        <!-- <div class=" flex"  *ngIf="data?.note">
            <label class="send-to-label">Notes</label>
            <p class="select-field !ml-[1.4rem] pl-[10px] !border-none !pt-0 !w-full" [innerHTML]="getSanitizedHtml(data?.note ||'---')"></p>
                        
        </div> -->
        
        <!-- Send To Section -->
        <div class="mb-6 flex max-w-[504px]">
            <label class="send-to-label !w-[6.25rem] !pt-[1rem]">Send to</label>
            <mat-form-field appearance="outline" class="!h-[25px] !w-[100%]">
                <mat-label>Select Status</mat-label>
                <mat-select formControlName="status" class="border-b border-t">
                  <mat-option value="pending" class="border-t border-gray-300">Pending</mat-option>
                  <mat-option value="approved" class="border-t border-gray-300">Approved</mat-option>
                  <mat-option value="rejected" class="border-t border-gray-300">Rejected</mat-option>
                  <mat-option value="request-changes" class="border-t border-gray-300">Requested Changes</mat-option>
                  <mat-option value="clarification" class="border-t border-gray-300">Clarification Required</mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('status').hasError('required') && form.get('status').touched">
                    Status is required.
                  </mat-error>
              </mat-form-field>
                        
        </div>

        <!-- Add Comment Section -->
        <div class="p-0 m-0 !mt-[20px]">
            <label for="add-note" class="send-to-label">Comments</label>
            <app-rich-textEditor 
                (contentChange)="approverNote($event)" 
                [resetEditor]="resetRichTextEditor"
                [richTextValue]="form.get('approver_note')?.value"></app-rich-textEditor>
        </div>

        <!-- Action Buttons -->
        <div class="mt-6 flex justify-end space-x-2 mb-[30px]">
            <button class="close-btn" (click)="closeApproval()">
                Close
            </button>
            <button class="send-btn" (click)="sendApproval()">
                Send
            </button>
        </div>
    </div>
</div>
</form>